/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

import Vue from 'vue'
import GmapCluster from 'vue2-google-maps/dist/components/cluster'
import * as vueGoogleMap from 'vue2-google-maps'

Vue.use(vueGoogleMap, {
  load: {
    key: process.env.VUE_APP_GOOGLE_API,
    libraries: 'places'
  }
})

Vue.component('GmapCluster', GmapCluster)
